export default {"src":"/_next/static/media/PlusButtonRed.150c716b.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};